'use strict';
const mmWidgets = require('./mm-widgets');
require('./section-handler-widget');
mmWidgets.fn.googleFileConfirmationWidget = function (pageController) {
	return mmWidgets.each(this, function () {
		const widget = this.sectionHandlerWidget();
		pageController.addEventListener('fileConfirmationRequired', fileContext => {
			if (fileContext.isMigrated) {
				widget.showSection('migrated');
			} else {
				widget.showSection('legacy');
			}
		});
	});
};
